import BaseView from '@/store/modules/components/BaseView'

export default class OrgDocumentsView extends BaseView {
    constructor() {
        super('orgDocuments')
    }
}
